import { render, staticRenderFns } from "./ColoredSlider.vue?vue&type=template&id=7ddc178f&scoped=true&"
import script from "./ColoredSlider.vue?vue&type=script&lang=js&"
export * from "./ColoredSlider.vue?vue&type=script&lang=js&"
import style0 from "./ColoredSlider.vue?vue&type=style&index=0&id=7ddc178f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc178f",
  null
  
)

export default component.exports